var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "d-flex align-items-center",
      class: [_vm.width, _vm.variant]
    },
    [
      _c(
        "div",
        {
          staticClass: "dot",
          style: { background: `${_vm.iconBackground} !important` }
        },
        [
          _c("em", {
            staticClass: "title-icon mt-1",
            class: _vm.icon,
            style: { color: _vm.iconColor, fontSize: _vm.iconSize }
          })
        ]
      ),
      _c(
        "div",
        {
          staticClass: "color-gray-7 font-16 font-weight-bold",
          class: { gradient: _vm.gradient }
        },
        [_vm._v(" " + _vm._s(_vm.title) + " ")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }